import {
  Box,
  BoxProps,
  Container,
  Flex,
  Heading,
  Spacer,
  Stack,
  Text,
} from "@chakra-ui/react";
import React from "react";

export const PageHeaderTitle = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Heading size="lg" color="brand.navy" py="2">
    {children}
  </Heading>
);

export const PageHeaderBackLink = ({
  children,
}: {
  children: React.ReactNode;
}) => <>{children}</>;

export const PageHeaderSubtitle = ({
  children,
}: {
  children: React.ReactNode;
}) => (
  <Text color="gray.500" fontWeight="medium" fontSize="lg">
    {children}
  </Text>
);

export const PageHeaderTabs = ({
  children,
}: {
  children?: React.ReactNode;
}) => (
  <Stack direction="row" spacing="4" mt="4">
    {children}
  </Stack>
);

export const PageHeader = ({
  children,
  buttons,
  ...props
}: BoxProps & {
  buttons?: React.ReactNode;
  children: React.ReactNode;
}) => {
  const hasTabs = React.Children.toArray(children).some(
    (child) =>
      React.isValidElement(child) && child.type === (<PageHeaderTabs />).type
  );

  return (
    <Box
      bg="white"
      pt="12"
      mb="4"
      pb={hasTabs ? "0" : "12"}
      shadow="sm"
      {...props}
    >
      <Container maxW="7xl">
        <Flex alignItems="flex-start">
          <Box>{children}</Box>
          <Spacer />
          {buttons && (
            <Flex alignItems="center" my="2">
              {buttons}
            </Flex>
          )}
        </Flex>
      </Container>
    </Box>
  );
};
